<template>
    <section>
        <div class="row">
            <div class="col s12">
                <div class="card-panel">
                    <div class="row">
                        <h5 class="col s12">Filtros</h5>

                        <div class="input-field col s6">
                            <i class="material-icons prefix">search</i>
                            <input style="display: inline-block; width: 70%;"
                                   type="text" id="txt_pesq_filter"
                                   v-model="filtro.termo_pesquisa"
                                   placeholder="Pesquise algum termo...">
                            <label for="txt_pesq_filter">Pesquisa</label>

                            <a @click.prevent="obtemListaDeInscricoes"
                               style="display: inline-block;"
                               class="btn-small waves-effect waves-light blue lighten-1">Buscar</a>
                        </div>

                        <div class="input-field col s6">
                            <select ref="sel_edital_pesq"
                                    name="sel_edital_pesq"
                                    id="sel_edital_pesq"
                                    class="materialize-select"
                                    @change.stop="obtemListaDeInscricoes"
                                    v-model.number="filtro.edital_selecionado"
                                    tipo="materialize">
                                <option value="0">Todos</option>
                                <option v-for="(edital, edital_i) in editais"
                                        :key="edital_i"
                                        :title="edital.ano"
                                        :value="edital.id">{{ edital.ano }}</option>
                            </select>
                            <label for="sel_edital_pesq">Edital</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col s12">
                <div class="card">
                    <div class="card-content">
						<h5 v-if='incompleto()' style="color:red">
							Atenção! Há inscrição(ões) apenas salva(s). É preciso enviá-la(s) em definitivo para efetivar sua inscrição. 
						</h5>
                        <div class="row">
                            <div class="col s12">
                                <a class="btn waves-effect waves-light indigo right"
                                   :disabled="!temEditalAberto"
                                   :href="pCreateRoute"
                                   title="Fazer nova inscrição."><i class="material-icons left">add</i>Nova Inscrição</a>

                                <loading id="spinner" :active="loading" :can-cancel="false" :is-full-page="false"></loading>

                                <section v-if="!loading">
                                    <section v-if="inscricoes.length === 0">
                                        <div class="row">
                                            <div class="col s12">
                                                <p class="label-info-nao-encontrada">Não foram encontradas inscrições cadastradas para esse usuário.</p>
                                            </div>
                                        </div>
                                    </section>

                                    <section v-else>
                                        <div class="row">
                                            <div class="col s12 m12 l12 xl12">
                                                <table class="responsive-table striped">
                                                    <thead style="font-size: small;">
                                                    <tr>
                                                        <th>
                                                            <span>Edital</span>
                                                        </th>
                                                        <th>
                                                            <span>Ação</span>
                                                        </th>
                                                        <th>
                                                            <span>Coordenador</span>
                                                        </th>
                                                        <th>
                                                            <span>Data de Cadastro</span>
                                                        </th>
                                                        <th>
                                                            <span>Data de Envio</span>
                                                        </th>

                                                        <th v-if="editalEstaNoPeriodoDeDivulgacaoDoResultadoInicialOuCumprimentoDeExigenciaDaAnaliseTecnica">
                                                            <span>Resultado Inicial (Análise Técnica)</span>
                                                        </th>
														<th v-if="editalEstaNoPeriodoDeDivulgacaoDoResultadoFinalDaAnaliseTecnica">
                                                            <span>Resultado Final (Análise Técnica)</span>
                                                        </th>
                                                        <th v-if="editalEstaNoPeriodoDoResultadoPreliminarDasAvaliacoes">
                                                            <span>Resultado Preliminar (Avaliação)</span>
                                                        </th>
                                                        <th v-if="editalEstaNoPeriodoDosResultadosFinais">
                                                            <span>Resultado Final (Avaliação)</span>
                                                        </th>
                                                        <th></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody style="font-size: small;">
                                                    <tr v-for="(inscricao, i) in inscricoes" :key="i" style="font-size: small;">

                                                        <td>
                                                            <span>
                                                                {{ inscricao.edital }}
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <span class="tooltipped" :data-tooltip="inscricao.acao" data-position="bottom">
                                                                {{ truncarTexto(inscricao.acao, 20) }}
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <span class="tooltipped" :data-tooltip="inscricao.usuario" data-position="bottom">
                                                                {{ truncarTexto(inscricao.usuario, 20) }}
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <span>
                                                                {{ inscricao.data_cadastro }}
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <span>
                                                                {{ inscricao.data_ultima_atualizacao }}
                                                            </span>
                                                        </td>

                                                        <!-- Resultados da Análise Técnica e outras ações -->
                                                        <td v-if="editalEstaNoPeriodoDeDivulgacaoDoResultadoInicialOuCumprimentoDeExigenciaDaAnaliseTecnica
														|| editalEstaNoPeriodoDeDivulgacaoDoResultadoFinalDaAnaliseTecnica">
                                                            <span v-if="!inscricao.analise_tecnica"
                                                                  class="label-info-nao-encontrada">Não foi realizada análise técnica dessa inscrição.</span>

                                                            <p v-else>
                                                                <a class="tooltipped"
                                                                   data-position="left"
                                                                   :data-tooltip="retornaMensagemDoTooltipDeAcordoComResultadoAnalise(inscricao.analise_tecnica.resultado)"
                                                                   style="cursor:pointer;"
                                                                   @click="verDetalhesDoResultadoDaAnaliseTecnica(inscricao.analise_tecnica)">
                                                                    <span :class="retornaCssBadgeDeAcordoComResultadoAnalise(inscricao.analise_tecnica.resultado)"
                                                                          data-badge-caption="">{{ inscricao.analise_tecnica.resultado }}</span></a>
                                                            </p>

                                                            <br>

                                                            <p v-if="exibeBotaoDeCorrecaoDaProposta(inscricao)">
                                                                <a class="amber-text text-darken-3"
                                                                   :href="pCorrigirInscricaoRoute.replace('inscricaoId', inscricao.id)"
                                                                   title="Corrigir proposta"
                                                                   style="cursor: pointer;">Corrigir proposta</a>
                                                            </p>

                                                            <p v-else-if="inscricao.reenvio_cumprimento_analise_tecnica">
                                                                <span class="label-info-baixo-destaque">A proposta foi alterada e reenviada em {{ inscricao.reenvio_cumprimento_analise_tecnica }}.</span>
                                                            </p>
                                                        </td>

                                                        <!-- Resultados das Avaliações e outras ações -->
                                                        <td v-if="editalEstaNoPeriodoDoResultadoPreliminarDasAvaliacoes || editalEstaNoPeriodoDosResultadosFinais">
                                                            <span v-if="!inscricao.analise_tecnica"
                                                                  class="new badge grey"
                                                                  style="font-size: 0.65rem !important; font-weight: bold !important;"
                                                                  data-badge-caption="">NÃO HOUVE ANÁLISE TECNICA</span>

                                                            <a v-else-if="inscricao.analise_tecnica.resultado === 'ELIMINADO'"
                                                               class="tooltipped"
                                                               data-position="left"
                                                               data-tooltip="Clique para visualizar análise técnica."
                                                               style="cursor:pointer;"
                                                               :href="pInscricaoVisualizarAvaliacoesRoute.replace('inscricaoId', inscricao.id)">
                                                                <span style="font-size: 0.65rem !important; font-weight: bold !important;"
                                                                    :class="retornaCssBadgeDeAcordoComResultadoAnalise(inscricao.analise_tecnica.resultado)"
                                                                    data-badge-caption="">ELIMINADO ANÁLISE TECNICA</span></a>


                                                            <a v-else
                                                               class="tooltipped"
                                                               data-position="left"
                                                               data-tooltip="Clique para visualizar avaliações."
                                                               style="cursor:pointer;"
                                                               :href="pInscricaoVisualizarAvaliacoesRoute.replace('inscricaoId', inscricao.id)">
                                                                <span class="new badge cyan darken-1"
                                                                      style="font-weight: bold !important;"
                                                                      data-badge-caption=""> {{ inscricao.resultado_avaliacoes }} ponto(s) </span></a>

                                                            <p v-if="inscricao.analise_tecnica && inscricao.analise_tecnica.resultado !== 'ELIMINADO'">
                                                                <br>
                                                                <a class="blue-text text-darken-2"
                                                                   title="Entenda a nota da avaliação."
                                                                   style="cursor: pointer;"
                                                                   @click="entendaANotaDaAvaliacao(inscricao)"><i class="material-icons tiny left" style="margin-right: 5px !important;">info</i><span>Entenda a nota da avaliação.</span></a>
                                                            </p>

                                                        </td>

                                                        <!-- Botões de Ações -->
                                                        <td>

                                                            <a :disabled="!inscricao.pode_editar"
                                                               class="btn-floating btn-small grey darken-4"
                                                               :href="pEditRoute.replace('inscricaoId', inscricao.id)"
                                                               title="Editar inscrição">
                                                                <i class="material-icons white-text">edit</i>
                                                            </a>

                                                            &nbsp;

                                                            <a class="btn-floating btn-small blue lighten-1"
                                                               :href="pShowInscricaoRoute.replace('inscricaoId', inscricao.id)"
                                                               title="Visualizar inscrição">
                                                                <i class="material-icons white-text">visibility</i>
                                                            </a>
															
															&nbsp;

                                                            <button v-if='inscricao.parcial === true && inscricao.pode_editar'
															   class="btn-floating btn-small red lighten-1"
                                                               @click='apagarParcial(inscricao.id)'
                                                               title="Apagar inscrição parcial">
                                                                <i class="material-icons white-text">delete</i>
                                                            </button>

															&nbsp;
															<a v-if='(editalEstaNoPeriodoDePedidoDeRecursos && inscricao.notas_avaliacoes.length) || (inscricao.recurso && !editalEstaNoPeriodoDosResultadosFinais)' class="btn-floating btn-small teal lighten-1"
                                                               :href="'/recursos/' + inscricao.id"
                                                               title='Recurso'>
                                                                <i class="material-icons white-text">replay</i>
                                                            </a>
															<a v-if='inscricao.recurso && editalEstaNoPeriodoDosResultadosFinais' class="btn-floating btn-small teal lighten-1"
                                                               :href="'/recursos/parecer/' + inscricao.id"
                                                               title='Parecer do recurso'>
                                                                <i class="material-icons white-text">autorenew</i>
                                                            </a>

                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </section>
                                </section>

                            </div>
                        </div>
                    </div>
                    <div class="card-action">
                        <div class="row">
                            <div class="col s12">
                                <div class="left">
                                    <strong>Total de registros por pagina</strong>
                                    <select name="total_regs_pag"
                                            class="browser-default"
                                            style="width: auto;"
                                            id="total_regs_pag"
                                            @change="obtemListaDeInscricoes"
                                            v-model="paginacao.regsPorPage">
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="15">15</option>
                                        <option value="20">20</option>
                                    </select>
                                </div>

                                <div class="center">
                                    <vuepaginate :totalPage="paginacao.totalPages"
                                                 v-model="paginacao.currentPage"
                                                 nextText="Próximo"
                                                 prevText="Anterior"
                                                 :withNextPrev="true"
                                                 :customActiveBGColor="'#000099'"
                                                 @btnClick="mudaPagina"></vuepaginate>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import vuepaginate from "../utils/vuepaginate";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import * as swalMsg from "../utils/swalMsg";

export default {
    name: "inscricaos",
    components: {
        vuepaginate,
        Loading,
    },
    props: {
        pEditais: {
            type: String,
            default: null
        },
        pTemEditalAberto: {
            type: String,
            default: null
        },
        pCreateRoute: {
            type: String,
            default: null
        },
        pEditRoute: {
            type: String,
            default: null
        },
        pShowInscricaoRoute: {
            type: String,
            default: null
        },
        pCorrigirInscricaoRoute: {
            type: String,
            default: null
        },
        pInscricaoVisualizarAvaliacoesRoute: {
            type: String,
            default: null
        },
        successMsg: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            //Váriaveis de Paginação
            paginacao: {
                regsPorPage: 5,
                totalPages: 1,
                totalRegs: 0,
                currentPage: 1,
            },

            //Filtros
            filtro: {
                termo_pesquisa: null,
                edital_selecionado: 0,
            },

            //Dados da tela e controle do formulário
            loading: false,
            temEditalAberto: !this.pTemEditalAberto ? false : (/true|1|"1"/i).test(JSON.parse(this.pTemEditalAberto)),
            editais: !this.pEditais ? [] : JSON.parse(this.pEditais),
            inscricoes: []
        }
    },
    computed: {
        editalSelecionado() {
            if(!this.filtro.edital_selecionado || this.filtro.edital_selecionado === 0)
                return null
            else
                return _.find(this.editais, (edital) => { return edital.id === this.filtro.edital_selecionado; })
        },

        editalEstaNoPeriodoDeCumprimentoDeExigenciasDaAnaliseTecnica(){
            if(!this.editalSelecionado)
                return false;
            else
                return this.editalSelecionado.esta_no_periodo_de_cumprimento_de_exigencias_da_analise_tecnica;
        },

        editalEstaNoPeriodoDeDeDivulgacaoDoResultadoInicialDaAnaliseTecnica(){
            if(!this.editalSelecionado)
                return false;
            else
                return this.editalSelecionado.esta_no_periodo_de_divulgacao_do_resultado_inicial_da_analise_tecnica;
        },

		editalEstaNoPeriodoDeDivulgacaoDoResultadoFinalDaAnaliseTecnica(){
            if(!this.editalSelecionado)
                return false;
            else
                return this.editalSelecionado.esta_no_periodo_de_divulgacao_do_resultado_final_da_analise_tecnica;
        },

        editalEstaNoPeriodoDeDivulgacaoDoResultadoInicialOuCumprimentoDeExigenciaDaAnaliseTecnica(){
            if(!this.editalSelecionado)
                return false
            else {
                return (
                    this.editalEstaNoPeriodoDeDeDivulgacaoDoResultadoInicialDaAnaliseTecnica
                    ||
                    this.editalEstaNoPeriodoDeCumprimentoDeExigenciasDaAnaliseTecnica
                );
            }
        },
		editalEstaNoPeriodoDePedidoDeRecursos(){
            if(!this.editalSelecionado)
                return false;
            else
                return this.editalSelecionado.esta_no_periodo_de_pedido_de_recursos;
        },

        editalEstaNoPeriodoDoResultadoPreliminarDasAvaliacoes(){
            if(!this.editalSelecionado)
                return false;
            else
                return this.editalSelecionado.esta_no_periodo_do_resultado_preliminar_das_avaliacoes;
        },

		editalEstaNoPeriodoDosResultadosFinais(){
            if(!this.editalSelecionado)
                return false;
            else
                return this.editalSelecionado.esta_no_periodo_dos_resultados_finais;
        },
    },

    methods: {
        //Método de paginação
        mudaPagina: function(page){
            this.paginacao.currentPage = page
            this.obtemListaDeInscricoes()
        },

        //Métodos de consulta de dados
        async obtemListaDeInscricoes(){
            let payload = {
                paginacao: this.paginacao,
                filtro: this.filtro
            }

            this.loading = true

            await this.$http.get(`/api/inscricaos/lista/todos/${payload.filtro.termo_pesquisa}/${payload.filtro.edital_selecionado}/${payload.paginacao.currentPage}/${payload.paginacao.regsPorPage}`).then(response => {
                this.paginacao.totalPages = parseInt(response.body.totalDePaginas)
                this.paginacao.currentPage = parseInt(response.body.paginaAtual)
                this.paginacao.totalRegs = parseInt(response.body.totalDeRegistros)
                this.inscricoes = response.body.inscricoes
            }, error => {
                Swal.fire({ title: 'Ocorreu um erro!', text: error.body.msg, footer: error.body.exception, icon: 'error'})
            })

            this.loading = false
        },

        selecionaUltimoEdital(){
            if(this.editais && this.editais.length > 0)
                this.filtro.edital_selecionado = this.editais[0].id
        },

        retornaCssBadgeDeAcordoComResultadoAnalise(resultado)
        {
            let spanBadge = 'new badge '

            switch (resultado) {
                case "HABILITADO":
                    spanBadge = spanBadge + 'green';
                    break;
                case "EXIGÊNCIA":
                    spanBadge = spanBadge + 'amber darken-3';
                    break;
                case "ELIMINADO":
                    spanBadge = spanBadge + 'red';
                    break;
                default:
                    spanBadge = spanBadge + 'grey';
                    break;
            }

            return spanBadge;

        },

        exibeBotaoDeCorrecaoDaProposta(inscricao){
            return inscricao.analise_tecnica && inscricao.analise_tecnica.resultado === 'EXIGÊNCIA'
                && this.editalEstaNoPeriodoDeCumprimentoDeExigenciasDaAnaliseTecnica
                && !inscricao.reenvio_cumprimento_analise_tecnica
        },

        retornaMensagemDoTooltipDeAcordoComResultadoAnalise(resultado){
            switch (resultado) {
                case "HABILITADO":
                    return 'Visualize o parecer que o analista técnico fez para sua inscrição.';
                case "EXIGÊNCIA":
                    return 'Visualize as especificação das correções necessárias na proposta que o analista técnico fez para sua inscrição.';
                case "ELIMINADO":
                    return 'Visualize o parecer eliminatório que o analista técnico fez para sua inscrição.';
                default:
                    return 'N/a.';
            }
        },

        truncarTexto(texto, caracteres = 10){
            return _.truncate(texto, {
                'omission': ' [...]',
                'length': caracteres,
            })
        },

        verDetalhesDoResultadoDaAnaliseTecnica(analise_tecnica = null){
            let htmlText = null;

            if(analise_tecnica){
                let titulo = analise_tecnica.mensagem;

                if(analise_tecnica.resultado === 'HABILITADO')
                    htmlText = '<p>' + analise_tecnica.parecer_eliminado + '</p>'

                else if(analise_tecnica.resultado === 'ELIMINADO')
                    htmlText = '<p>' + analise_tecnica.parecer_eliminado + '</p>'

                else if(analise_tecnica.resultado === 'EXIGÊNCIA')
                    htmlText = '<p>' + analise_tecnica.especificacao_correcoes_proposta + '</p>'


                Swal.fire({
                    title: titulo,
                    html: htmlText,
                    showClass: {
                        popup: 'animate__animated animate__fadeInDown'
                    },
                    hideClass: {
                        popup: 'animate__animated animate__fadeOutUp'
                    }
                })
            }
        },
		incompleto() {
			var inscricoes = this.inscricoes,
				i = inscricoes.length;
				
			while (--i >= 0) 
				if (inscricoes[i].parcial && inscricoes[i].pode_editar) 
					return true;
			
			return false;
		},
        entendaANotaDaAvaliacao(inscricao){
            let titulo = 'Entenda a nota da sua inscrição.';

            let htmlText = 'A nota é formada pela soma do resultado das avaliações:' + '<br>';

            let somaAvaliacoes = 0;

            _.forEach(inscricao.notas_avaliacoes, (av, i) => {
                somaAvaliacoes += av.pontuacao_total;

                if(i === 0)
                    htmlText += `<strong> * Avaliação ${i + 1} : ${av.pontuacao_total.toFixed(2)}`;
                else
                    htmlText += ` + Avaliação ${i + 1} : ${av.pontuacao_total.toFixed(2)} </strong><br>`;
            })

            let mediaAvaliacoes = somaAvaliacoes / inscricao.notas_avaliacoes.length;

            let resultadoFinal = mediaAvaliacoes + inscricao.analise_tecnica.pontuacao;

            htmlText += `Totalizando: <strong>${somaAvaliacoes.toFixed(2)}</strong>`;

            htmlText += `<p>Dividido pelo número de avaliações válidas que neste caso foram <strong>${inscricao.notas_avaliacoes.length} avaliações.</strong><br>`

            htmlText += `Totalizando: <strong>${mediaAvaliacoes.toFixed(2)}</strong></p>`;

            htmlText += `<p>A esse resultado é somada a nota recebida na <i>Análise Técnica</i> que foi <strong>${inscricao.analise_tecnica.pontuacao}.</strong><br>`

            htmlText += `Chegando na nota final: <strong>${resultadoFinal.toFixed(2)}</strong></p>`;


            Swal.fire({
                title: titulo,
                html: htmlText,
                showClass: {
                    popup: 'animate__animated animate__fadeInDown'
                },
                hideClass: {
                    popup: 'animate__animated animate__fadeOutUp'
                }
            })
        },
		async apagarParcial(inscricaoId) {
			let confirmaEnvio = true;
			
			await Swal.fire({
                    title: 'Tem certeza que deseja apagar a inscrição?',
                    text: "Após apagar a inscrição parcial, essa ação não poderá ser desfeita!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode apagar!',
                    cancelButtonText: 'Cancelar.'
                }).then((result) => {
                    confirmaEnvio = result.isConfirmed
                })

            if(confirmaEnvio)
				this.$http.get('/inscricaos/remover/' + inscricaoId).then(response => {
						window.location.href = `inscricaos/?msg=${response.body.msg}`
					}, error => {
						const exceptionMensagem = _.replace(_.replace(error.body.exception, '#nr1', '<b>'), '#nr2', '</b>')

						Swal.fire({ title: 'Ocorreu um erro!', html: exceptionMensagem, footer: error.body.msg, icon: 'error'})
					})
		}
    },
    mounted() {
        if(this.successMsg)
            swalMsg.toastMsg('top-center', 'success', this.successMsg)

        this.selecionaUltimoEdital()

        this.obtemListaDeInscricoes()

    },
    updated() {
        $('.tooltipped').tooltip();
    }
}
</script>

<style scoped>

</style>
